module.exports = __webpack_public_path__ + "img/zhengfujigou.dfbb2a98.png";